export const START_TAB_TRACKING = 'START_TAB_TRACKING';
export const FINISH_TAB_TRACKING = 'FINISH_TAB_TRACKING';
